import { Component, OnInit, Input } from '@angular/core';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-premium-ads',
  templateUrl: './premium-ads.component.html',
  styleUrls: ['./premium-ads.component.scss']
})
export class PremiumAdsComponent implements OnInit {

  searchString: any;
  categories: any;

  businessAds:any;
  serverImgUrl:any;
  userInfoId:any;

   @Input('businessData') ads!: PremiumAdsComponent;
  
  constructor(private adsService: BusinessAdsService,
    private route: ActivatedRoute) {  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
    })
    if(this.userInfoId){
      this.getBusinessAdsByUUId();
    }
    this.serverImgUrl = environment.IMG_URL;
  }

  noAds:any;
  // Get all business
  getBusinessAdsByUUId(): void {
    this.adsService.getBusinessAdsByUUId(this.userInfoId).subscribe({
      next: (res:any) => {
        if (res.success !== 0) {
          this.businessAds = res.data; 
        } else {
          this.noAds = true; 
        }
        }
      }
    );
  }
}
